import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { StudentProfile } from '../pathways-ui/models/student-profile.model';

@Injectable({
  providedIn: 'root'
})
export class SpBackofficeService {

  backofficeController: string = '/api/Backoffice';

  constructor(private http: HttpClient) { }

  getStudentProfile(): Observable<StudentProfile> {
    return this.http
      .get<StudentProfile>(this.backofficeController + `/profile`);
  }
}
